import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { ReservationsApiService } from './services/reservations-api.service';
import { ReservationsState } from './state/reservations.state';

export const reservationsPageRouteConfig: Route = {
  path: 'reservations',
  loadComponent: () => import('./reservations-page.component').then((c) => c.ReservationsPageComponent),
  providers: [provideStates([ReservationsState]), ReservationsApiService]
};
